import {Box, Divider, Grid, InputAdornment, Typography} from '@mui/material';
import {t} from 'i18next';
import React, {useState} from 'react';
import './DocumentSelection.scss';
import ArrTextField from '../../../../common/arr-text-field/ArrTextField';
import {Clear, Search} from '@mui/icons-material';
import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ExtendedTreeItemProps} from '../../../../../shared/interfaces';
import {ISavedSearchResponse} from '../../../../../api/types/savedsearch.types';
import SharedSavedSearchTree from './shared-saved-search-tree/SharedSavedSearchTree';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {ReactComponent as ProcessingIcon} from '../../../../../assets/images/icon-processing.svg';
import {ReactComponent as ProcessingIconDisabled} from '../../../../../assets/images/processingIconDisabled.svg';
import ArrBanner from '../../../../common/arr-banner/ArrBanner';
import {ReactComponent as InfoIcon} from '../../../../../assets/images/info-icon.svg';
import {useSelector, useDispatch} from 'react-redux';
import {RootState, AppDispatch} from '../../../../../redux/store';
import {setCreateCustomIndex} from '../../../../../redux/slice/createCustomIndexSlice';
import classNames from 'classnames';
const mockSelectedSearchData = {
  data: {
    searchID: 418345,
    docID: '010019101816155715',
    searchName: 'Business Purpose',
    result: '',
    families: 'No',
    status: 'DRAFT',
    submitTime: null,
    lastSubmittedBy: 'Gokila Bharath',
    lastCompleteTime: '2026-02-25T07:43:48.97',
    createdName: 'Gokila Bharath',
    createdOn: '2026-02-25T07:43:48.97',
    lastUpdateByName: 'Gokila Bharath',
    lastUpdateOn: '2026-02-25T07:43:48.97',
    lastDocCount: '150,000',
    sharedFlag: '',
    scheduleId: 0,
    isOldAudioSavedSearch: false,
    securityGroupName1: '145,000',
    securityGroupname2: '130,000',
    index: 'Standard',
    syntax: `("breach of contract" w/10 ("settlement" or "negotiation" or "resolution" or "arbitration" or "agreement")) or 
                      ("intellectual property" w/15 ("infringement" or "lawsuit" or "dispute" or "violation" or "ownership")`,
  },
};

const DocumentSelectionCustomIndex: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {isReadOnlyView} = useSelector(
    (state: RootState) => state.indexManagement
  );
  const [searchInput, setSearchInput] = useState<string>('');
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [selectedItemData, setSelectedItemData] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const [selectedRow, setSelectedRow] = useState<ISavedSearchResponse | null>(
    null
  );
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const handleClearSearch = () => {
    setSearchInput('');
  };

  const handleSearchKeyEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const searchText = searchInput?.trim();
      setSearchKeyword(searchText ?? '');
    }
  };

  const getSelectedTreeItem = (itemId: string) => {
    setSelectedRow(null);
    setSelectedItem(itemId);
    const parsedSavedSearchId = Number(itemId);
    dispatch(
      setCreateCustomIndex({
        SavedSearchId: Number.isNaN(parsedSavedSearchId)
          ? null
          : parsedSavedSearchId,
      })
    );
  };

  const getSelectedTreeItemData = (
    item: TreeViewBaseItem<ExtendedTreeItemProps>
  ) => {
    setSelectedItemData(item);
  };

  return (
    <Box className="doc-custom-index-wrapper">
      <Box className="doc-index-header">
        <Typography
          className="typo-text subhead2_size doc-index-title-text"
          data-testid={`document-selection-doc-selection-title`}
        >
          {t('ingestions.custom-index.stepper-tab-2.doc-selection-title')}
        </Typography>
      </Box>
      <Box className="dox-index-content">
        <Grid container spacing={6} rowSpacing={12}>
          <Grid
            size={{xs: 12, sm: 6}}
            className="saved-search-dropdown-content"
          >
            <Box className="select-saved-search-title">
              <Typography
                className="typo-text subhead3_size"
                data-testid={`document-selection-select-saved-search-title`}
              >
                {t(
                  'ingestions.custom-index.stepper-tab-2.select-saved-search-title'
                )}
              </Typography>
              <Typography
                className="typo-text body3_size"
                data-testid={`document-selection-select-sub-header`}
              >
                {t('ingestions.custom-index.stepper-tab-2.select-sub-header')}
              </Typography>
            </Box>
            <Box
              className={classNames(
                'search-box',
                isReadOnlyView && 'search-box-inactive'
              )}
            >
              <ArrTextField
                state={isReadOnlyView ? 'inactive' : 'enabled'}
                sizeVariant="medium"
                tabIndex={isReadOnlyView ? 0 : -1}
                className="search-input"
                placeholder={t(
                  `ingestions.custom-index.stepper-tab-2.search-placeholder`
                )}
                aria-label={t(
                  'ingestions.custom-index.stepper-tab-2.search-placeholder'
                )}
                dataTestId="doc-selection-search-input"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  if (e.target.value.trim() === '') {
                    setSearchKeyword('');
                  }
                }}
                onKeyDown={handleSearchKeyEnter}
                slotProps={{
                  inputLabel: {shrink: false},
                  input: {
                    endAdornment: searchInput ? (
                      <InputAdornment
                        position="end"
                        className="clear-adornment-icon"
                        onClick={() => {
                          if (searchKeyword.trim() !== '') {
                            setSearchInput('');
                            setSearchKeyword('');
                          }
                        }}
                        data-testid={`clear-searchdoc-selection`}
                      >
                        <Clear
                          onClick={handleClearSearch}
                          style={{cursor: 'pointer'}}
                          data-testid="search-clear-btn"
                        />
                      </InputAdornment>
                    ) : (
                      <InputAdornment
                        position="end"
                        className="search-adornment-icon"
                      >
                        <Search
                          className={
                            isReadOnlyView ? 'search-icon-inactive' : ''
                          }
                        />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Box>
            <Box>
              <SharedSavedSearchTree
                getSelectedTreeItem={getSelectedTreeItem}
                getSelectedTreeItemData={getSelectedTreeItemData}
                searchKeyword={searchKeyword}
              />
            </Box>
          </Grid>

          <Grid
            size={{xs: 12, sm: 6}}
            className="selected-search-details-content"
          >
            <Box
              sx={{visibility: selectedItem ? 'visible' : 'hidden'}}
              className="search-details-box"
            >
              <Box className="details-header-box">
                <Typography
                  className="typo-text subhead3_size"
                  data-testid={`document-selection-search-detail-title`}
                >
                  {t(
                    'ingestions.custom-index.stepper-tab-2.search-detail-title'
                  )}{' '}
                  {mockSelectedSearchData.data.searchID}
                </Typography>
                <Typography
                  className="typo-text body4_size details-sub-headings"
                  data-testid={`document-selection-detail-id`}
                >
                  {t('ingestions.custom-index.stepper-tab-2.detail-id')}{' '}
                  {mockSelectedSearchData.data.docID}
                </Typography>
                <Divider className="details-text-divider" />
                <Typography
                  className="typo-text body4_size details-sub-headings"
                  data-testid={`document-selection-last-submit-time`}
                >
                  {t('ingestions.custom-index.stepper-tab-2.last-submit-time')}{' '}
                  {mockSelectedSearchData.data.lastUpdateOn}
                </Typography>
                <Typography
                  className="typo-text body4_size details-sub-headings"
                  data-testid={`document-selection-last-complete-time`}
                >
                  {t(
                    'ingestions.custom-index.stepper-tab-2.last-complete-time'
                  )}{' '}
                  {mockSelectedSearchData.data.lastCompleteTime}
                </Typography>
              </Box>

              <Box className="details-doc-count-box">
                <Box className="doc-refresh-count">
                  <Box className="doc-last-count">
                    <Typography
                      className="typo-text body3_size"
                      data-testid={`document-selection-last-doc-count`}
                    >
                      {t(
                        'ingestions.custom-index.stepper-tab-2.last-doc-count'
                      )}{' '}
                      {mockSelectedSearchData.data.lastDocCount}
                    </Typography>
                  </Box>
                  <span
                    tabIndex={isReadOnlyView ? 0 : -1}
                    aria-label="inactive-refresh-doc-button"
                    data-testid={`document-selection-refresh-doc-count`}
                  >
                    <ArrButton
                      variant="text"
                      size="small"
                      onClick={() => {}}
                      disabled={isReadOnlyView}
                      aria-label={t(
                        'ingestions.custom-index.stepper-tab-2.refresh-doc-count'
                      )}
                      dataTestId="refresh-doc-count-button"
                      startIcon={
                        isReadOnlyView ? (
                          <ProcessingIconDisabled />
                        ) : (
                          <ProcessingIcon />
                        )
                      }
                    >
                      {t(
                        'ingestions.custom-index.stepper-tab-2.refresh-doc-count'
                      )}
                    </ArrButton>
                  </span>
                  {mockSelectedSearchData.data.lastDocCount === '0' && (
                    <ArrBanner
                      type="contextual"
                      variant="warning"
                      className="banner-text"
                      bannerContent={t(
                        'ingestions.custom-index.stepper-tab-2.banner-info'
                      )}
                      startIcon={<InfoIcon />}
                      dataTestId="doc-selection-banner"
                    />
                  )}
                </Box>
                <Divider className="details-text-divider" />
                <Box
                  className="doc-security-group"
                  data-testid="doc-selection-sec-groups"
                >
                  <Typography
                    className="typo-text body4_size details-sub-headings"
                    data-testid={`document-selection-security-group-name1`}
                  >
                    {t(
                      'ingestions.custom-index.stepper-tab-2.security-group-name1'
                    )}{' '}
                    {mockSelectedSearchData.data.securityGroupName1}
                  </Typography>
                  <Typography
                    className="typo-text body4_size details-sub-headings"
                    data-testid={`document-selection-security-group-name2`}
                  >
                    {t(
                      'ingestions.custom-index.stepper-tab-2.security-group-name2'
                    )}{' '}
                    {mockSelectedSearchData.data.securityGroupname2}
                  </Typography>
                </Box>
              </Box>

              <Box
                className="details-index-box"
                data-testid="doc-selection-index-details"
              >
                <Typography
                  className="typo-text body3_size"
                  data-testid={`document-selection-index`}
                >
                  {t('ingestions.custom-index.stepper-tab-2.index')}{' '}
                  {mockSelectedSearchData.data.index}
                </Typography>
              </Box>

              <Box className="details-syntax-box">
                <Typography
                  className="typo-text body3_size"
                  data-testid={`document-selection-syntax-title`}
                >
                  {t('ingestions.custom-index.stepper-tab-2.syntax')}
                </Typography>
                <Typography
                  className="typo-text subhead5_size syntax-content"
                  data-testid={`document-selection-syntax`}
                >
                  {mockSelectedSearchData.data.syntax}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DocumentSelectionCustomIndex;
